import { useEffect } from 'react';

/**
 * La page publique est le HTML statique /privacy.html
 * (Meta et les crawlers n'exécutent pas l'app React).
 */
function Privacy() {
  useEffect(() => {
    window.location.replace('/privacy.html');
  }, []);

  return null;
}

export default Privacy;
